<div class="contest-groups__wrapper">
  <div class="contest-groups__header">
    <h2 class="contest-groups__title">{{ "contest.manage" | translate }}</h2>
    <button mat-button
      (click)="editRegistration()"
      data-e2e="contest-group-edit-registration"
      class="contest-groups__add-remove-button">
      <div>{{ "contest.add_remove_classes" | translate }}</div>
    </button>
  </div>
  <table mat-table
    [dataSource]="dataSource"
    multiTemplateDataRows
    class="contest-groups__table">
    <ng-container matColumnDef="name">
      <td mat-cell
        *matCellDef="let element"
        class="contest-groups__table-cell contest-groups__name-cell">
        <mat-icon svgIcon="chevron-down-circle"></mat-icon>
        <span>{{ element.name }}</span>
      </td>
    </ng-container>
    <ng-container matColumnDef="learnersCount">
      <td mat-cell
        *matCellDef="let element"
        class="contest-groups__table-cell contest-groups__learners-cell">
        @if (element.learnersCount <= 1) {
          <span>{{ element.learnersCount }}&nbsp;{{ "contest.learner" | translate }}</span>
        } @else {
          <span>{{ element.learnersCount }}&nbsp;{{ "contest.learners" | translate }}</span>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="progressBar">
      <td mat-cell
        *matCellDef="let element"
        class="contest-groups__table-cell contest-groups__progress-bar-cell">
        <progress class="contest-groups__progress-bar"
          [value]="element.progressBar"
          max="100"
          role="progressbar">
        </progress>
      </td>
    </ng-container>
    <ng-container matColumnDef="progressCount">
      <td mat-cell
        *matCellDef="let element"
      class="contest-groups__table-cell contest-groups__progress-count-cell">{{ element.progressCount }}&nbsp;%</td>
    </ng-container>

    <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
    <ng-container matColumnDef="expandedDetail">
      <td mat-cell
        *matCellDef="let element"
        [attr.colspan]="columnsToDisplay.length"
        class="contest-groups__detail-cell">
        <div class="contest-groups__detail-wrapper"
          [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
          <mat-list class="contest-groups__detail-list"
            role="list">
            @for (learner of element.learners; track learner) {
              <mat-list-item
                class="contest-groups__detail-list-item"
                role="listitem">
                <div class="contest-groups__learner-label">{{ learner.label }}</div>
                <progress class="contest-groups__learner-progress-bar"
                  [value]="learner['progression']"
                  max="100"
                  role="progressbar">
                </progress>
                <div class="contest-groups__learner-progress-count">{{ learner['progression'] }}&nbsp;%</div>
              </mat-list-item>
            }
          </mat-list>
        </div>
      </td>
    </ng-container>

    <tr mat-row
      *matRowDef="let element; columns: columnsToDisplay;"
      class="contest-groups__table-row"
      [ngClass]="{'contest-groups__table-row--expanded': expandedElement === element}"
      tabindex="0"
      (click)="expandedElement = expandedElement === element ? null : element"
      (keyup.enter)="expandedElement = expandedElement === element ? null : element"
      (keyup.space)="expandedElement = expandedElement === element ? null : element"
      [attr.aria-label]="element.name">
    </tr>
    <tr mat-row
      *matRowDef="let row; columns: ['expandedDetail']"
      class="contest-groups__detail-row">
    </tr>
  </table>
</div>